export const config = {
  title: "Bill Ryan Home and Key Group LPT Realty | Real Estate Services in Fairhaven, MA",
  meta: {
    description:
      "Bill Ryan Home and Key Group LPT Realty offers expert real estate services in Fairhaven, MA, assisting clients in buying and selling homes with personalized guidance.",
    keywords: [
      'Real Estate Fairhaven',
      'Homes for Sale',
      'Bill Ryan Realtor',
      'Home and Key Group',
      'LPT Realty',
      'Property Listings',
      'Massachusetts Real Estate',
      'Buy Home Fairhaven',
      'Sell Home Fairhaven',
      'Real Estate Agent'
    ],
    author: "Bill Ryan Home and Key Group LPT Realty",
    canonicalUrl: 'https://www.billryansellsbristolcounty.com/',
  },
  sections: {
    header: {
      businessName: "Bill Ryan Home and Key Group LPT Realty",
    },
    sectionB: {
      heroTitle: "Bill Ryan Home and Key Group LPT Realty",
      heroSubtitle: 'Your Trusted Real Estate Partner in Fairhaven, MA',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '5084411186',
      phoneLabel: '(508) 441-1186',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2061789423/photo/multi-dwelling-development.jpg?s=612x612&w=0&k=20&c=x6HFaWz6IXqiCtd0ujo7m1VtS762EJjqITpym23JHNw=",
      cardData: [
        {
          title: 'Mission',
          description:
            'At Bill Ryan Home and Key Group LPT Realty, our mission is to provide exceptional real estate services, guiding you through every step of buying or selling your home.',
        },
        {
          title: 'Vision',
          description:
            'Our vision is to be the leading real estate agency in Fairhaven, MA, known for our commitment to client satisfaction and market expertise.',
        },
        {
          title: 'Why Choose Us',
          description:
            'With over 27 years of experience, we offer personalized solutions tailored to your real estate needs, ensuring a seamless and rewarding experience.',
        },
      ],
      description:
        "Bill Ryan Home and Key Group LPT Realty specializes in residential real estate, offering comprehensive services to help you find your dream home or sell your property efficiently.",
    },
    sectionC: {
      servicesTitle: 'Communities We Serve',
      servicesDescription:
        "Discover the vibrant communities where Bill Ryan Home and Key Group LPT Realty offers expert real estate services.",
      cards: [
        {
          title: 'Assonet',
          description:
            'A picturesque village known for its rich history and scenic landscapes.',
          imageSrc:
            'https://media.istockphoto.com/id/1388239619/photo/aerial-top-view-middle-class-neighborhood-in-south-california-usa.jpg?s=612x612&w=0&k=20&c=QLMGqgFObKtsuER3nmT328FFAzzQGjttNfKpVLJ3ZIc=',
          imageAlt: 'Assonet Community',
        },
        {
          title: 'East Freetown',
          description:
            'A charming area offering a blend of rural beauty and modern amenities.',
          imageSrc:
          'https://media.istockphoto.com/id/1488438637/photo/row-of-homes.jpg?s=612x612&w=0&k=20&c=kVsYFuVKHD8FOb9jxPgC134M8Q8yJ61cmsSRtqJPkIM=',
          imageAlt: 'East Freetown Community',
        },
        {
          title: 'East Taunton',
          description:
            'A vibrant community with a rich industrial heritage and diverse housing options.',
          imageSrc:
          'https://media.istockphoto.com/id/1437086785/photo/multi-color-leaves-in-neighbourhood-park-at-weston-road-and-major-mackenzie-dr-woodbridge.jpg?s=612x612&w=0&k=20&c=1t0OVT0dmjCVZQgnBBD6qLXpN9vBlhC92hL-dHKZTFQ=',
          imageAlt: 'East Taunton Community',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'New Bedford',
        'North Dartmouth',
        'Rehoboth',
        'Somerset',
        'Westport'
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://images.marketleader.com/MarketingImages/72/2404572_normal.jpg',
        alt: "Bill Ryan and Team",
      },
      aboutText: [
        "With over 27 years of experience, Bill Ryan Home and Key Group LPT Realty is dedicated to providing top-notch real estate services in Fairhaven, MA, and surrounding areas.",
        "Our team is committed to understanding your unique needs and delivering personalized solutions to ensure a successful real estate transaction.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Bill Ryan Home and Key Group LPT Realty",
      businessName: "Bill Ryan Home and Key Group LPT Realty",
      contact: {
        phone: '5084411186',
        phoneLabel: '(508) 441-1186',
        email: 'billryanreadvisor@gmail.com',
        website: 'https://www.billryansellsbristolcounty.com/',
        address: '86 Huttleston Ave, Fairhaven, MA 02719',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: 'https://www.facebook.com/profile.php?id=100012825245032',
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '86 Huttleston Ave, Fairhaven, MA 02719',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2949.123456789012!2d-70.9031234!3d41.6372345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3f1234567890b%3A0x1234567890abcdef!2s86%20Huttleston%20Ave%2C%20Fairhaven%2C%20MA%2002719!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
